export default __webpack_public_path__ + "static/media/logo_4.f231e8a8.png";